/**
 * platform.js — 平台检测与通用工具
 * 职责：仅包含环境判断、Promise 超时、Store 更新等纯工具函数
 * 不依赖任何原生桥接或业务逻辑
 */

const ua = navigator.userAgent
export const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
export const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
export const isPC = !isAndroid && !isIOS

/**
 * Promise 超时包装器
 * @param {Function} promiseFn — 返回 Promise 的函数
 * @param {number} timeoutMs — 超时毫秒数
 * @param {*} timeoutResult — 超时后 resolve 的默认值
 */
export function withTimeout(promiseFn, timeoutMs = 5000, timeoutResult) {
  return new Promise((resolve) => {
    let settled = false
    const timer = setTimeout(() => {
      if (!settled) {
        settled = true
        console.warn(`[Bridge] 操作超时(${timeoutMs}ms)，返回默认值`, timeoutResult)
        resolve(timeoutResult)
      }
    }, timeoutMs)

    promiseFn().then((result) => {
      if (!settled) {
        settled = true
        clearTimeout(timer)
        resolve(result)
      }
    })
  })
}

/**
 * 更新 Vuex Store 的辅助函数
 */
export function updateStore(commitName, data) {
  if (window.Vue && window.Vue.prototype.$store) {
    window.Vue.prototype.$store.commit(commitName, data)
  }
}
